import { FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const ULContainer = styled.ul`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const ListPremiumFree = styled.li`
  display: flex;
  align-items: center;
  margin: 0px 12px;
  font-weight: ${FONT_WEIGHT.NORMAL};
`;
